import { render } from "./HeaderNoticeDropdown.vue?vue&type=template&id=288eb119&scoped=true"
import script from "./HeaderNoticeDropdown.vue?vue&type=script&lang=js"
export * from "./HeaderNoticeDropdown.vue?vue&type=script&lang=js"

import "./HeaderNoticeDropdown.vue?vue&type=style&index=0&id=288eb119&scoped=true&lang=css"

import exportComponent from "/Users/april/Desktop/hz_pro_vue3/mail-task-front-end/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-288eb119"]])

export default __exports__